import uly from "ulysses/core";
import ko from "knockout";
import notification_template from "ulysses/components/notificationlist.html";
import HalResource from "ulysses/api";

class NotificationModel {
    constructor(params) {
        this.items = ko.observableArray([]);
        this.visible_items = ko.pureComputed(()=>{
            return this.items().filter((i)=>{return i.visible()});
        });

        this.is_empty = ko.pureComputed(()=> {
            return this.visible_items().length <= 0;
        })
        this.refresh_items();
        this.sub = setInterval(() => {
            this.refresh_items();
        }, 60000);
    }
    
    refresh_items() {
        let api = this._start;
        if (!api) {
            this._start = api = uly.api.start();
        }
        api.follow("uly:broadcast")
           .follow("item")
           .then((items) => {
               this.items(items.map((i)=>{i.visible=ko.observable(true); return i}));
           });
    }

    dispose() {
        s = this.sub;
        this.sub = null;
        clearInterval(s);
    }

    clear_notifications(ev, ui) {
        /* Can't use this here, as the this is wrong due to layers of callback */
        console.log("clearing all", ui.model, this);
        uly.api.start().follow("uly:broadcast").delete().then((result) => {
            uly.utils.show_results(result);
            ui.model.refresh_items();
            
        });
    }

    click(ev, ui) {
        /* Can't use this here, as the this is wrong due to layers of callback */
        var notification = ui.model;
        if (notification) {
            console.log("handle notification:", notification, this);
            if (notification.url) {
                uly.actions.goto(notification.url);
            }
            ui.model.visible(false);
            HalResource(ui.model).put(null, {"is_read": true});
        }
    }

}

ko.components.register("uly-notifications", {
    viewModel:NotificationModel,
    template: notification_template
});
